import React, { Component } from 'react';
import SearchBar from './components/SearchBar';
import ArticleList from './components/ArticleList';
import VideoList from './components/VideoList';
import SearchString from './components/SearchString';
import { connect } from 'react-redux';
import './index.css';
import logo from './gifs/logo.svg'
import Navbar from "./components/NAV/Navbar"
import ParticlesBg from "particles-bg";
let mainColor="#00bcd4";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = { }
    
  }
  

  render() {
    let config = {
      num: [4, 7],
      rps: 0.1,
      radius: [5, 40],
      life: [1.5, 3],
      v: [1, 2],
      tha: [-40, 40],
      alpha: [0.6, 0],
      scale: [.1, .1],
      position: "all",
      color: [mainColor],
      cross: "dead",
      // emitter: "follow",
      random: 10
    };
    if (Math.random() > 0.85) {
      config = Object.assign(config, {
        onParticleUpdate: (ctx, particle) => {
          ctx.beginPath();
          ctx.rect(
            particle.p.x,
            particle.p.y,
            particle.radius * 2,
            particle.radius * 2
          );
          ctx.fillStyle = particle.color;
          ctx.fill();
          ctx.closePath();
        }
      });
    }
    let firstSearch=false;
    
    if(this.props.state){
      if(this.props.state.links.load){
        firstSearch=true;
      }
    }
    return (
      <div className="App">
       <Navbar />
       {(firstSearch)?<div>  
      <div className="container-fluid" style={{marginTop:`2vh`}}>
        <div className="row" style={{paddingLeft:`7vw`,textAlign:`center`}}>
        <div onClick={()=>{window.location.reload()}} className="col-md-2 col-xs-12 row">
          </div>
        <div className="col-md-10 col-xs-12" ><SearchBar/></div>
        </div>
      </div>
      <div style={{marginTop:`4vh`,paddingLeft:`3vh`,paddingRight:`3vh`,paddingBottom:`1vh`,paddingTop:`1vh`}}><SearchString /></div>
      <div style={{marginTop:`0vh`,padding:`3vh`}}>
        <div><h3>Related Articles</h3></div>
        <div><ArticleList/></div></div>
      <div style={{marginTop:`7vh`,padding:`3vh`}}>
      <div><h3>Related Videos</h3></div>
        <div><VideoList/></div></div>
      
      </div>:<div>
        <div style={{marginTop:`10vh`,textAlign:`center`,padding:`5vh`}}>
          <div onClick={()=>{window.location.reload()}}>
          <div>
        <svg height="25%" viewBox="0 -31 512 511" width="15%" xmlns="http://www.w3.org/2000/svg"><path d="m256 448.714844h256v-320.644532l-276.015625-20.015624zm0 0" fill="#03232e" className="svg-elem-1"></path><path d="m0 128.070312v320.644532h256v-340.660156zm0 0" fill="#07485e" className="svg-elem-2"></path><path d="m271.945312 305.285156h192.214844v30h-192.214844zm0 0" fill="#00cc76" className="svg-elem-3"></path><path d="m47.839844 305.285156h192.214844v30h-192.214844zm0 0" fill="#00ff94" className="svg-elem-4"></path><path d="m271.945312 177.714844h192.214844v30h-192.214844zm0 0" fill="#00cc76" className="svg-elem-5"></path><path d="m47.839844 177.714844h192.214844v30h-192.214844zm0 0" fill="#00ff94" className="svg-elem-6"></path><path d="m47.839844 241.5h63.785156v30h-63.785156zm0 0" fill="#00ff94" className="svg-elem-7"></path><path d="m400.375 241.5h63.785156v30h-63.785156zm0 0" fill="#00cc76" className="svg-elem-8"></path><path d="m47.839844 369.070312h63.785156v30h-63.785156zm0 0" fill="#00ff94" className="svg-elem-9"></path><path d="m400.375 369.070312h63.785156v30h-63.785156zm0 0" fill="#00cc76" className="svg-elem-10"></path><path d="m256 .5-20.015625 63.785156 20.015625 63.785156h256v-127.570312zm0 0" fill="#b4d2d7" className="svg-elem-11"></path><path d="m0 .5h256v127.570312h-256zm0 0" fill="#e1ebf0" className="svg-elem-12"></path><path d="m47.839844 49.285156h31.890625v30h-31.890625zm0 0" fill="#ff4a4a" className="svg-elem-13"></path><path d="m111.625 49.285156h31.894531v30h-31.894531zm0 0" fill="#ffd422" className="svg-elem-14"></path><g fill="#00cc76"><path d="m175.410156 49.285156h31.894532v30h-31.894532zm0 0" className="svg-elem-15"></path><path d="m368.484375 241.5h-112.484375l-10.007812 15 10.007812 15h112.484375zm0 0" className="svg-elem-16"></path><path d="m368.484375 399.070312v-30h-112.484375l-10.007812 15 10.007812 15zm0 0" className="svg-elem-17"></path></g><path d="m143.515625 241.5h112.484375v30h-112.484375zm0 0" fill="#00ff94" className="svg-elem-18"></path><path d="m143.515625 369.070312h112.484375v30h-112.484375zm0 0" fill="#00ff94" className="svg-elem-19"></path></svg>
          </div>
          <div className="KnowSearch" style={{fontSize:`30px`,fontFamily:`system-ui`}}>
            Knowledge Search
          </div>
          </div>
          <div style={{marginTop:`5vh`,marginLeft:`3vw`}}>
          <SearchBar/>
          </div>
          </div>
          <div style={{position:`fixed`,bottom:`0`}}>
          <svg width="100vw" height="25vh">
      <path 
        fill="#0abbff" 
        d="
          M0 67
          C 273,183
            822,-40
            1920.00,106 

          V 359 
          H 0 
          V 67
          Z">
        <animate 
          repeatCount="indefinite" 
          fill="#454599" 
          attributeName="d" 
          dur="15s" 
          values="
            M0 77 
            C 473,283
              822,-40
              1920,116 

            V 359 
            H 0 
            V 67 
            Z; 

            M0 77 
            C 473,-40
              1222,283
              1920,136 

            V 359 
            H 0 
            V 67 
            Z; 

            M0 77 
            C 973,260
              1722,-53
              1920,120 

            V 359 
            H 0 
            V 67 
            Z; 

            M0 77 
            C 473,283
              822,-40
              1920,116 

            V 359 
            H 0 
            V 67 
            Z
            ">
        </animate>
      </path>
    </svg>
            </div>
        </div>}
        <ParticlesBg type="custom" config={config} className="bubbles" bg={true} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log('i am called when store is updated',state)
  return {
    state: state
  };
}

const mapDispatchToProps=(dispatch)=>{
return ({
  // addLinksToStore:(payload)=>{dispatch({type:'ADD_LINKS',payload:payload})}
})
}

export default connect(mapStateToProps,mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js